<template>
  <div class="uni-max">
    <nav>
      <div class="nav nav-tabs details-cal-pills border-0" id="nav-tab" role="tablist" style="background:var(--p4surface5, #1C1C1C)">
        <a class="nav-item nav-link active" id="nav-roi" style="background:none;" data-toggle="tab" href="#roi" role="tab" aria-controls="nav-roi" aria-selected="true">ROI</a>
        <a class="nav-item nav-link" id="nav-snp" style="background:none;" data-toggle="tab" href="#snp" role="tab" aria-controls="nav-snp" aria-selected="true">Expected Selling or Purchase Price</a>
      </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">
      <!-- ROI -->
      <div class="tab-pane fade show active" id="roi" role="tabpanel" aria-labelledby="nav-roi">
        <div class="row m-0 calpage-d roi">
          <div class="col-lg-6 cd-padding">
            <div class="cal-results">
              <div class="p-4 uni-max-xs">
                <div class="cal-result-div">
                  <div class="cal-subtitle">ROI</div>
                  <div class="cal-redtitle mt-2">{{addComma(sroI)}} %</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 cd-padding">
            <div class="cal-form-container">
              <div class="cal-label">Purchase Price</div> 
              <div class="filter-price-wrapper">
                <span class="filter-price-rm">RM</span>
                <input type='number' v-model="purcPrice" class="filter-price-range">
              </div>
              
              <div class="cal-label">Net Yearly Rental Income (RM)</div> 
              <div class="filter-price-wrapper">
                <span class="filter-price-rm">RM</span>
                <input type='number' v-model="roiRent" class="filter-price-range">
              </div>

              <button @click="calculate" class="cal-btn">
                <span v-if="isloaded">Calculate my ROI</span>
                <div v-else class="spinner-border text-light" role="status" style="width: 1rem; height: 1rem;">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- SnP -->
      <div class="tab-pane fade" id="snp" role="tabpanel" aria-labelledby="nav-snp">
        <div class="row m-0 calpage-d roi">
          <div class="col-lg-6 cd-padding">
            <div class="cal-results">
              <div class="p-4 uni-max-xs">
                <div class="cal-result-div">
                  <div class="cal-subtitle">Expected Selling or Purchase Price</div>
                  <div class="cal-redtitle mt-2">RM {{addComma(sexpSnp)}}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 cd-padding">
            <div class="cal-form-container">
              <div class="cal-label">Net Yearly Rental Income</div> 
              <div class="filter-price-wrapper">
                <span class="filter-price-rm">RM</span>
                <input type='number' v-model="netRent" class="filter-price-range">
              </div>
              
              <div class="cal-label">Expected Return (%)</div> 
              <div class="filter-price-wrapper">
                <input type='number' v-model="expReturn" class="filter-price-range">
                <span class="filter-price-rm ml-auto">%</span>
              </div>
              <div class="mt-2"><small>Ideal percentage is from 3% - 8%</small></div>

              <button @click="calculate" class="cal-btn">
                <span v-if="isloaded">Calculate</span>
                <div v-else class="spinner-border text-light" role="status" style="width: 1rem; height: 1rem;">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ROI',
    data: function() {
        return{
          purcPrice: null,
          roiRent: null,
          netRent: null,
          expReturn: null,
          isloaded: true,

          // Results (update when press calculate)
          sroI: '',
          sexpSnp: '',
        }
    },
    mounted() {
      this.purcPrice = 500000;
      this.roiRent = 15000;
      this.netRent = 15000;
      this.expReturn = 3;

      this.sroI = this.roI;
      this.sexpSnp = this.expSnp;
    },
    computed: {
      roI() {
        return (this.roiRent*100/this.purcPrice).toFixed(2);
      },
      expSnp() {
        return (this.netRent*100/this.expReturn).toFixed(2);
      }
    },
    methods: {
      addComma: function (num) {
        if (num != null) {
          var num_parts = num.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        } else {
          return '';
        }
      },
      calculate: function() {
        this.isloaded = false;

        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
          this.isloaded = true;

          // Update Results
          this.sroI = this.roI;
          this.sexpSnp = this.expSnp;
        }, 500);
      },
    },
  }
</script>